<template>
  <div class="input-group d-flex contenedorBuscador">
    <div class="input-group-prepend ">
            <span class="input-group-text" id="basic-addon1">
              <i class="fas fa-search"></i>
            </span>
    </div>
    <input type="text" class="form-control col-10 col-md-8 bucadorGeneral " id="bucadorGeneral"
           placeholder="Buscar" aria-label="Username" aria-describedby="basic-addon1"
           v-model="textSearch" @focus="enfocado=true" @blur="enfocado=false" @mouseover="mouseenfocado=true">
    <div class="col-10 mt-5 preguntas" v-bind:class="{  'border-bottom-1':Focus }" @mouseover="mouseenfocado=true"
         @mouseleave="mouseenfocado=false" v-if="contenidosFilter && textSearch.length > 2">
      <div class="" v-if="contenidosFilter.length && enfocado">
        <div class="card ">
          <div class="card-body bg-white text-left ">
            <div class="col-12 py-1" v-for="country of contenidosFilter">
              <a @click="redirigir(cliente,country.categoria,country.id)"
                 :href="'/' + cliente + '/'+country.categoria+ '/'+ country.slug ">
                {{country.titulo}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import list_ApiUrl from '../../compartida/listApiUrl';

  export default {
    name: "buscador",
    data() {
      return {
        cliente: '',
        textSearch: "",
        contenidos: [],
        enfocado: false,
        mouseenfocado: false
      }
    },
    computed: {
      contenidosFilter: function () {
        var textSearch = this.textSearch;
        return this.contenidos.filter(function (el) {
          // console.log('el', el.contenido.toLowerCase().indexOf(textSearch.toLowerCase().replace(/ /g, '-')) !== -1);
          if (el.contenido.toLowerCase().indexOf(textSearch.toLowerCase().replace(/ /g, '-')) !== -1){
            return  el.contenido.toLowerCase().indexOf(textSearch.toLowerCase().replace(/ /g, '-')) !== -1;
        }else if (el.slug.toLowerCase().indexOf(textSearch.toLowerCase().replace(/ /g, '-')) !== -1) {
            return el.slug.toLowerCase().indexOf(textSearch.toLowerCase().replace(/ /g, '-')) !== -1;
          }

          // return el.slug.toLowerCase().indexOf(textSearch.toLowerCase().replace(/ /g, '-')) !== -1;
        });
      },

      Focus() {
        if (this.enfocado && this.mouseenfocado) {
          this.enfocado = true;
          return true
        }

        if (!this.enfocado && this.mouseenfocado) {
          this.enfocado = true;
          return true
        }

        if (!this.enfocado && !this.mouseenfocado) {
          this.enfocado = false;
          return false
        }

        if (this.enfocado && !this.mouseenfocado) {
          this.enfocado = false;
          return false
        }
      }
    },
    created() {
      var that = this;
      let cliente = this.$route.params.cliente;
      this.cliente = cliente;

      axios.get(`${list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.API_URL_PUBLICO + list_ApiUrl.API_URL_PUBLICO_BUSCADOR}/${cliente}`)
        .then(function (response) {
          that.contenidos = response.data;
          console.log('***', that.contenidos, response.data);
        }).catch(function (error) {
        console.log(error);
      });
    },
    methods: {
      redirigir: function (cliente, categoria, contenido_id) {
        this.$router.go(`/${cliente}/${categoria}/${contenido_id}`);
      }
    }
  }
</script>

<style scoped lang="scss">

  #basic-addon1 {
    margin-right: -40px;
    margin-left: 20px;
    font-size: 16px;
    z-index: 100;
  }

  .bucadorGeneral {
    line-height: 30px;
    padding-left: 50px;
  }

  .comun-contenedor-buscador {
    #basic-addon1 {
      margin-right: -40px;
      margin-left: 0px;
      font-size: 16px;
      z-index: 100;
    }

    .bucadorGeneral {
      padding-left: 25px;
    }
  }

  .contenedorBuscador {
    & .bucadorGeneral {
      box-shadow: 0 3px 15px rgba(46, 37, 69, 0.08), inset 0 2px 0 white;
      border: solid #E4E3E6 1px;
      background: #f5f5f9;
      border-radius: 10px 10px 10px 10px !important;
      -moz-border-radius: 10px 10px 10px 10px !important;;
      -webkit-border-radius: 10px 10px 10px 10px !important;;
      transition: all 300ms ease;
      &:hover {
        box-shadow: 0 7px 15px rgba(46, 37, 69, 0.1), inset 0 2px 0 white;
        background: white;
        border-color: #d1d1d1;
      }
      &:focus {
        outline: none;
        box-shadow: 0 7px 15px rgba(46, 37, 69, 0.1), inset 0 2px 0 white;
        background: white;
        border-color: rgba(0, 150, 136, 0.16)
      }
    }
  }

  .preguntas {
    z-index: 100;
    max-height: 200px;
    position: absolute;
    overflow-y: scroll;
    margin: auto;

    &::-webkit-scrollbar {
      width: 2px; /*=> ancho del scroll*/
      background-color: #cecece; /*=> Color del fondo principal */
    }
    &::-webkit-scrollbar-track {
      background-color: rgba(33, 25, 21, 0.3); /*=> color de fondo del trayecto del scroll */
      -webkit-box-shadow: inset 0 0px 10px rgba(0, 0, 0, 0.38); /*=> sombra */
    }
    &::-webkit-scrollbar-thumb {
      background-color: #009688; /*=> color del indicador del scroll */
      border-radius: 10px; /*=> bordes redondeados */
      -webkit-box-shadow: inset 0 2px 15px #009688; /*=> sombra */
    }
  }

  .border-bottom-1 {
    border-bottom: 1.5px solid #dee2e6 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/publico/share/buscador.vue